import { render, staticRenderFns } from "./UserNotificationSettings.vue?vue&type=template&id=1fe16226&scoped=true&"
import script from "./UserNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./UserNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationSettings.vue?vue&type=style&index=0&id=1fe16226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe16226",
  null
  
)

export default component.exports